/**
 * Sort invoices based on column and direction
 * @param {Array} invoices - Array of invoice objects
 * @param {Object} sortConfig - Sort configuration {column, direction}
 * @returns {Array} Sorted array of invoices
 */
export const sortInvoices = (invoices, sortConfig) => {
  if (!invoices || !Array.isArray(invoices)) {
    return [];
  }

  const sorted = [...invoices];

  sorted.sort((a, b) => {
    let aVal = a[sortConfig.column];
    let bVal = b[sortConfig.column];

    // For uploader, sort by name
    if (sortConfig.column === 'uploadedBy') {
      aVal = a.uploader?.firstName || '';
      bVal = b.uploader?.firstName || '';
    }

    // For amount, use numeric sorting
    if (sortConfig.column === 'amount') {
      aVal = aVal == null ? 0 : parseFloat(aVal);
      bVal = bVal == null ? 0 : parseFloat(bVal);

      if (sortConfig.direction === 'ASC') {
        return aVal - bVal;
      } else {
        return bVal - aVal;
      }
    }

    // For other fields (strings, dates), use string comparison
    if (aVal == null) aVal = '';
    if (bVal == null) bVal = '';

    if (sortConfig.direction === 'ASC') {
      return aVal > bVal ? 1 : -1;
    } else {
      return aVal < bVal ? 1 : -1;
    }
  });

  return sorted;
};
